import React from 'react';
import { ToastContainer } from 'react-toastify';

export const ToastProvider = () => {
  return (
    <ToastContainer position={'bottom-center'} hideProgressBar={true}/>
  )
};
